export const lossReport = {
	label: "Pérdidas",
	title: "Informe de Pérdidas",
	period: "Período",
	emptyText: "No se encontró ningún dato",
	add: "Agregar Pérdida",
	export: "Descargar en Excel",
	description:
		"El informe de pérdidas agrupa todos los movimientos de inventario marcados como pérdidas. De esta forma, el administrador podrá tener una visión general de los productos que se perdieron.",
	periodInfo: "Mostrando informe de {{since}} hasta {{until}}",
	columns: {
		sku: "SKU",
		product: "Producto",
		inventory: "Inventario",
		refund: "Pérdida de reembolso",
		inventoryLoss: "Pérdida de inventario",
		manual: "Pérdida manual",
		subtotal: "Subtotal",
		production: "Pérdida de producción",
		total: "Pérdida total",
		totalLoss: "Valor total de la pérdida",
	},
	sheet: {
		title: "Informe de pérdida",
		fileName: "informe-perdida",
		sku: "SKU",
		product: "Producto",
		inventory: "Inventario",
		refund: "Pérdida de reembolso",
		inventoryLoss: "Pérdida de inventario",
		manual: "Pérdida manual",
		subtotal: "Subtotal",
		production: "Pérdida de producción",
		basicStorageUnit: "Unidad",
		total: "Pérdida total",
		totalLoss: "Valor total de la pérdida",
	},
	addModal: {
		loading: "Cargando...",
		storageSelect: "Seleccionar inventario",
		productSelect: "Seleccionar producto",
		none: "Ningún producto encontrado",
		lossQuantity: "Cantidad perdida",
		count: "Cantidad",
		date: "Fecha",
		other: "Agregar otro producto",
	},
	validations: {
		validStorage: "Seleccione un inventario válido",
		validProduct: "Seleccione un producto válido",
		validQuantity: "Ingrese una cantidad válida",
		validDate: "Seleccione una fecha válida",
	},
	totalLossTooltip: "Valor total de pérdida referente al período seleccionado.",
	totalLossHeading: "Valor total de la pérdida",
};
